import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { REST_API_URL, PERMISSION_CREATE, APP_PATH } from "../../Utils/Global";

import PermissionCheck from '../Permissions/PermissionCheck';

import Combobox from '../Helper/Combobox';
import Grid from '../Helper/Grid';
import GridFilter from '../Helper/GridFilter';

import Projet from '../Entity/Projet';

/**
* Class ProjetList
* ProjetList view component
**/
class ProjetList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      objectif: {}
    };
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Projet;

    // Filter list
    const filters = this.getFilters();

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes projets</h2>
        <GridFilter title="Filtrer les projets" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />

        <PermissionCheck component={objectClass.getClassName()} permission={PERMISSION_CREATE}>
          <div className="addManyToOneFromSearch">
            <Combobox url={REST_API_URL + "objectifs/?estContrat=false"} optionValueKey="idObjectif" optionLabelKey="libelle"
              onChange={this.onObjectifSelect.bind(this)} placeholder="Choisir un objectif" />

              <p className="gridBottomToolbar">
                <Link to={APP_PATH + "/objectifs/" + ((this.state.objectif === undefined) ? undefined : this.state.objectif.idObjectif) + "/projets/add"}>
                  <Button disabled={this.state.objectif === undefined || this.state.objectif.idObjectif === undefined} bsStyle="success" className="gridAddObjectBtn">Ajouter un projet</Button>
                </Link>
              </p>
          </div>
        </PermissionCheck>

        <Grid title="Projets" ref={"grid" + objectClass.name} path="projets" objectPath="projets" objectClass={objectClass}
          customFieldsUrl="fields-search" ignoreAdd={true} height="400px" hidden={false} />

      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + Projet.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyArrayFilter
  * Filters the grid
  **/
  applyArrayFilter(fieldName, value) {
    const grid = this.refs["grid" + Projet.name];
    grid.applyArrayFilter(fieldName, value);
  }

  /**
  * applyDateIntervalFilter
  * Filters the grid
  **/
  applyDateIntervalFilter(fieldName, values) {
    const grid = this.refs["grid" + Projet.name];
    grid.applyDateIntervalFilter(fieldName, values);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["grid" + Projet.name];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + Projet.name];
    grid.clearFilters();
  }

  /**
  * onObjectifSelect
  * Handle Objectif selection
  **/
  onObjectifSelect(objectif) {
    this.setState({
      objectif: objectif
    });
  }

  /**
  * getFilters
  * Returns the filters
  **/
  getFilters() {
    return [{
      title: "Nom du projet",
      type: "text",
      name: "libelle",
      rowIdx: 0
    },{
      title: "Date de début",
      type: "dateinterval",
      name: "dateDebut",
      rowIdx: 0
    },{
      title: "Date de fin",
      type: "dateinterval",
      name: "dateFin",
      rowIdx: 0
    },
    // {
    //   type: "map",
    //   layer: "projet",
    //   name: "idProjet",
    //   rowIdx: 0
    // },
    {
      title: "Objectif",
      type: "combo",
      name: "idObjectif",
      optionValueKey: "idObjectif",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/objectifs/?estContrat=false",
      rowIdx: 1
    },{
      title: "Responsable",
      type: "combo",
      name: "idResponsable",
      optionValueKey: "idResponsable",
      optionLabelKey: "libelleResponsable",
      url: REST_API_URL + "/responsables/",
      rowIdx: 1
    },{
      title: "Prestataire",
      type: "combo",
      isArray: true,
      name: "prestataires",
      optionValueKey: "idPrestataire",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/prestataires/",
      rowIdx: 1
    },{
      title: "Est une clause environnementale",
      type: "combo",
      name: "estEnvironnemental",
      dataSource: {collection: [{id: "true", name: "Oui"}, {id: "false", name: "Non"}]},
      rowIdx: 1
    },{
      title: "Thématique",
      type: "combo",
      multi: true,
      isArray: true,
      name: "thematiques",
      optionValueKey: "idThematique",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/thematiques/",
      rowIdx: 2
    },{
      title: "Mots-clé",
      type: "combo",
      multi: true,
      isArray: true,
      name: "motCles",
      optionValueKey: "idMotCle",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/motcles/",
      rowIdx: 2
    }];
  }

}
export default ProjetList;



// WEBPACK FOOTER //
// ./src/views/Search/ProjetList.js